import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, Note } from 'ionic-angular';

import { ScheduleMarketing as Schedule, MasterMarketing as Master, NotesMarketing as Notes } from '@providers/index';

@Component({
  selector: 'page-notes',
  templateUrl: 'page.html'
})
export class DetailSchedulePage {

  form = {
    id : '',
    activity : '',
    date_start : '',
    date_end : '',
    description : '',
    pic_name :'',
    pic_id :'',
    tender_id:'',
    state_id: 1,
    stage_id: '',
  };
  now_state_id = 1;
  note = '';
  listState:any = [];
  tender:any = {};
  loading:any;
  notes:any = [];
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public scheduleApi: Schedule,
    public notesApi: Notes,
    public masterApi: Master
  ) {

    this.getState();
    this.tender = this.navParams.get('tender');
    if(this.navParams.get('rec')!=undefined){
      this.form = this.navParams.get('rec');
      this.now_state_id = this.form.state_id;
      this.getNotes();
    }
    
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getState(){
    this.showLoading();
    let params = {};
    this.masterApi.state(params).subscribe((resp:any) => {
      this.listState = resp.data;
      this.loading.dismiss();
    });
  }

  getNotes(){
    let params = {
      tender_id : this.tender.id,
      related_id : this.form.id,
      related_to : 'Schedule'
    }
    this.notesApi.get(params).subscribe((resp:any) => {
      this.notes = resp.data;
    });
  }

  save(){    
    this.showLoading();
    this.form.tender_id = this.tender.id;
    let params = this.form;
    this.scheduleApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.add_note();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  add_note(){    
    this.showLoading();
    let params = {
      tender_id : this.tender.id,
      note : this.note,
      related_to : 'Schedule',
      related_id : this.form.id,
      related_notes : this.form.activity
    };
    this.notesApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/marketing/detail_schedule/page.ts